import { smb_fetch, getAgpApiUrl } from '@/api/operator/fetch';

export const getFinishSummary = (data: any) => {
  const url = getAgpApiUrl('task', 'get_dashboard_industry_finished_summary');
  return smb_fetch(url, {
    method: 'POST',
    data,
  });
};

export const getOngoingSummary = (data: any) => {
  const url = getAgpApiUrl('task', 'get_dashboard_industry_ongoing_summary');
  return smb_fetch(url, {
    method: 'POST',
    data,
  });
};

export const getFinishIndustryList = (data: any) => {
  const url = getAgpApiUrl('task', 'get_dashboard_industry_finished_list');
  return smb_fetch(url, {
    method: 'POST',
    ...data,
  });
};

export const getOngoingIndustryList = (data: any) => {
  const url = getAgpApiUrl('task', 'get_dashboard_industry_ongoing_list');
  return smb_fetch(url, {
    method: 'POST',
    ...data,
  });
};

export const getFinishProvinceList = (data: any) => {
  const url = getAgpApiUrl('task', 'get_dashboard_province_finished_list');
  return smb_fetch(url, {
    method: 'POST',
    data,
  }).then((res: any) => {
    return {
      ...res || {},
      data: {
        list: res?.data?.list || [],
        conf: {
          total_num: res?.data?.conf?.total_num || 0,
        },
      },
    };
  });
};

export const getOngoingProvinceList = (data: any) => {
  const url = getAgpApiUrl('task', 'get_dashboard_province_ongoing_list');
  return smb_fetch(url, {
    method: 'POST',
    data,
  }).then((res: any) => {
    return {
      ...res || {},
      data: {
        list: res?.data?.list || [],
        conf: {
          total_num: res?.data?.conf?.total_num || 0,
        },
      },
    };
  });
};

export const getFinishArchiList = (data: any) => {
  const url = getAgpApiUrl('task', 'get_dashboard_orbac_finished_list');
  return smb_fetch(url, {
    method: 'POST',
    ...data,
  }).then((res: any) => {
    return {
      ...res || {},
      data: {
        list: res?.data?.list || [],
        conf: {
          total_num: res?.data?.conf?.total_num || 0,
        },
      },
    };
  });
};

export const getOngoingArchiList = (data: any) => {
  const url = getAgpApiUrl('task', 'get_dashboard_orbac_ongoing_list');
  return smb_fetch(url, {
    method: 'POST',
    ...data,
  }).then((res: any) => {
    return {
      ...res || {},
      data: {
        list: res?.data?.list || [],
        conf: {
          total_num: res?.data?.conf?.total_num || 0,
        },
      },
    };
  });
};

export const getFinishEmployeeList = (data: any) => {
  const url = getAgpApiUrl('task', 'get_dashboard_employee_finished_list');
  return smb_fetch(url, {
    method: 'POST',
    ...data,
  }).then((res: any) => {
    return {
      ...res || {},
      data: {
        list: res?.data?.list || [],
        conf: {
          total_num: res?.data?.conf?.total_num || 0,
        },
      },
    };
  });
};

export const getOngoingEmployeeList = (data: any) => {
  const url = getAgpApiUrl('task', 'get_dashboard_employee_ongoing_list');
  return smb_fetch(url, {
    method: 'POST',
    ...data,
  }).then((res: any) => {
    return {
      ...res || {},
      data: {
        list: res?.data?.list || [],
        conf: {
          total_num: res?.data?.conf?.total_num || 0,
        },
      },
    };
  });
};

export const getFinishStrategyList = (data: any) => {
  const url = getAgpApiUrl('task', 'get_dashboard_strategy_finished_list');
  return smb_fetch(url, {
    method: 'POST',
    ...data,
  }).then((res: any) => {
    return {
      ...res || {},
      data: {
        list: res?.data?.list || [],
        conf: {
          total_num: res?.data?.conf?.total_num || 0,
        },
      },
    };
  });
};

// 获取拓品列表
export const getSpuList = (data: any) => {
  const url = getAgpApiUrl('crm_task_service/agency_spu', 'get_spu_list');
  return smb_fetch(url, {
    method: 'POST',
    ...data,
  });
};

// 获取服务商集团k框spu引入情况
export const getAgencySpuImport = (data: any) => {
  const url = getAgpApiUrl('crm_task_service/agency_spu', 'get_agency_spu_import');
  return smb_fetch(url, {
    method: 'POST',
    data,
  });
};

// 获取商品类目
export const getSpuCategoryList = (data: any = {}) => {
  const url = getAgpApiUrl('crm_task_service/agency_spu', 'get_cat_list');
  return smb_fetch(url, {
    method: 'GET',
    data,
  });
};

export const getOngoingStrategyList = (data: any) => {
  const url = getAgpApiUrl('task', 'get_dashboard_strategy_ongoing_list');
  return smb_fetch(url, {
    method: 'POST',
    ...data,
  }).then((res: any) => {
    return {
      ...res || {},
      data: {
        list: res?.data?.list || [],
        conf: {
          total_num: res?.data?.conf?.total_num || 0,
        },
      },
    };
  });
};

export const getFinishTaskList = (data: any) => {
  const url = getAgpApiUrl('task', 'get_dashboard_finished_list');
  return smb_fetch(url, {
    method: 'POST',
    ...data,
  }).then((res: any) => {
    return {
      ...res || {},
      data: {
        list: res?.data?.list || [],
        conf: {
          total_num: res?.data?.conf?.total_num || 0,
        },
      },
    };
  });
};

export const getOngoingTaskList = (data: any) => {
  const url = getAgpApiUrl('task', 'get_dashboard_ongoing_list');
  return smb_fetch(url, {
    method: 'POST',
    ...data,
  }).then((res: any) => {
    return {
      ...res || {},
      data: {
        list: res?.data?.list || [],
        conf: {
          total_num: res?.data?.conf?.total_num || 0,
        },
      },
    };
  });
};

export const getTaskTrend = (data: any) => {
  const url = getAgpApiUrl('task', 'get_dashboard_week_finished_list');
  return smb_fetch(url, {
    method: 'POST',
    ...data,
  }).then((res: any) => {
    return {
      ...res || {},
      data: {
        list: res?.data?.list || [],
        conf: {
          total_num: res?.data?.conf?.total_num || 0,
        },
      },
    };
  });
};

export const getShopOpportunitySummary = (data: any) => {
  const url = getAgpApiUrl('crm_task_service/customer_extend', 'get_summary');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  }, true, false);
};

export const getShopOpportunityList = (data: any) => {
  const url = getAgpApiUrl('crm_task_service/customer_extend', 'get_list');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    ...data,
  }, true, false);
};

export const getShopOpportunityDetail = (data: any) => {
  const url = getAgpApiUrl('crm_task_service/customer_extend', 'get_detail');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  }, true, false);
};

export const followShopOpportunity = (data: any) => {
  const url = getAgpApiUrl('crm_task_service/customer_extend', 'add_action');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
    loadingTip: '提交跟进记录中，请稍后',
  }, true, false);
};

export const assignShopOpportunity = (data: any) => {
  const url = getAgpApiUrl('crm_task_service/customer_extend', 'modify_follower_user');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
    loadingTip: '分配跟进人中，请稍后',
  }, true, false);
};

export const getShopOpportunityConfig = () => {
  const url = getAgpApiUrl('crm_task_service/customer_extend', 'config');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    isCache: true,
    data: {},
  }, false, false);
};

export const getUserList = (data: any) => {
  const url = getAgpApiUrl('crm_task_service/customer_extend', 'get_user_list');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    isCache: true,
    data,
  }, true, false).then((res: any) => ({
    ...res || {},
    data: res?.data?.map((item: any) => ({
      ...item,
      value: item.user_id,
      label: `${item.user_name}(${item.user_id})`,
    })),
  }));
};

export const getSelfOpportunitySummary = (data: any) => {
  const url = getAgpApiUrl('crm_task_service/agency_extend_customer', 'get_summary');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  }, true, false);
};

export const getSelfOpportunityList = (data: any) => {
  const url = getAgpApiUrl('crm_task_service/agency_extend_customer', 'get_list');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    ...data,
  }, true, false);
};

export const getSelfOpportunityDetail = (data: any) => {
  const url = getAgpApiUrl('crm_task_service/agency_extend_customer', 'get_detail');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  }, true, false);
};

export const followSelfOpportunity = (data: any) => {
  const url = getAgpApiUrl('crm_task_service/agency_extend_customer', 'add_action');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
    loadingTip: '提交跟进记录中，请稍后',
  }, true, false);
};

export const assignSelfOpportunity = (data: any) => {
  const url = getAgpApiUrl('crm_task_service/agency_extend_customer', 'modify_follower_user');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
    loadingTip: '分配跟进人中，请稍后',
  }, true, false);
};

export const deleteSelfOpportunity = (data: any) => {
  const url = getAgpApiUrl('crm_task_service/agency_extend_customer', 'delete');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    loadingTip: '删除中，请稍后',
    data,
  }, true, false);
};

export const getSelfOpportunityConfig = () => {
  const url = getAgpApiUrl('crm_task_service/agency_extend_customer', 'config');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    isCache: true,
    data: {},
  }, false, false);
};

export const getSelfOpportunityUserList = (data: any) => {
  const url = getAgpApiUrl('crm_task_service/agency_extend_customer', 'get_user_list');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    isCache: true,
    data,
  }, true, false).then((res: any) => ({
    ...res || {},
    data: res?.data?.map((item: any) => ({
      ...item,
      value: item.user_id,
      label: `${item.user_name}(${item.user_id})`,
    })),
  }));
};

export const getTaskFrame = () => {
  const url = getAgpApiUrl('task', 'get_frame_list');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    data: {},
  });
};

export const getIndustryList = (data: any) => {
  const url = getAgpApiUrl('task', 'get_industry_list');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    data,
  });
};

export const getIndustryLevel1List = () => {
  const url = getAgpApiUrl('task', 'get_industry_level1_list');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    data: {},
  });
};

export const getOrbacTeams = () => {
  const url = getAgpApiUrl('task', 'get_orbac_teams');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    data: {},
  });
};

export const getTaskProvince = () => {
  const url = getAgpApiUrl('task', 'get_province_list');
  return smb_fetch(url, {
    method: 'POST',
    isCache: true,
    data: {},
  });
};
